import {calendarEn, calendarRu} from './Calendar';
import cropControlEn from './CropControl/i18n.en';
import cropControlRu from './CropControl/i18n.ru';
import {datePickerEn, datePickerRu} from './DatePicker';
import emojiPickerEn from './EmojiPicker/i18n.en';
import emojiPickerRu from './EmojiPicker/i18n.ru';
import imagePickerEn from './ImagePicker/i18n.en';
import imagePickerRu from './ImagePicker/i18n.ru';
import modalsEn from './Modals/i18n.en';
import modalsRu from './Modals/i18n.ru';
import pageNavigationEn from './PageNavigation/i18n.en';
import pageNavigationRu from './PageNavigation/i18n.ru';
import {periodPickerEn, periodPickerRu} from './PeriodPicker';
import selectEn from './Select/i18n.en';
import selectRu from './Select/i18n.ru';
import stepperEn from './Stepper/i18n.en';
import stepperRu from './Stepper/i18n.ru';
import {timePickerEn, timePickerRu} from './TimePicker';
import timeSelectEn from './TimeSelect/i18n.en';
import timeSelectRu from './TimeSelect/i18n.ru';
import uploadAreaEn from './UploadArea/i18n.en';
import uploadAreaRu from './UploadArea/i18n.ru';

const i18nEdnaResourcesRu = {
  EdnaDatePicker: datePickerRu,
  EdnaTimePicker: timePickerRu,
  EdnaSelect: selectRu,
  EdnaModals: modalsRu,
  EdnaCalendar: calendarRu,
  EdnaEmojiPicker: emojiPickerRu,
  EdnaPeriodPicker: periodPickerRu,
  EdnaStepper: stepperRu,
  EdnaTimeSelect: timeSelectRu,
  EdnaUploadArea: uploadAreaRu,
  EdnaPageNavigation: pageNavigationRu,
  EdnaCropControl: cropControlRu,
  EdnaImagePicker: imagePickerRu,
};

const i18nEdnaResourcesEn = {
  EdnaDatePicker: datePickerEn,
  EdnaTimePicker: timePickerEn,
  EdnaSelect: selectEn,
  EdnaModals: modalsEn,
  EdnaCalendar: calendarEn,
  EdnaEmojiPicker: emojiPickerEn,
  EdnaPeriodPicker: periodPickerEn,
  EdnaStepper: stepperEn,
  EdnaTimeSelect: timeSelectEn,
  EdnaUploadArea: uploadAreaEn,
  EdnaPageNavigation: pageNavigationEn,
  EdnaCropControl: cropControlEn,
  EdnaImagePicker: imagePickerEn,
};

export {i18nEdnaResourcesRu, i18nEdnaResourcesEn};
